import type { AbstractValues } from '../common/abstract-values';

export enum StoreSizeTemplate {
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum StoreSectionTemplate {
  SECTIONS = 'sections',
  TABS = 'tabs',
}

export interface StoreValues extends AbstractValues {
  cardSize: StoreSizeTemplate;
  sectionsTemplate: StoreSectionTemplate;
}
